import React from 'react'

const IconAddFolder = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
       <path d="M720.31-177.96v-118.39H601.92v-55.96h118.39v-118.38h55.96v118.38h118.38v55.96H776.27v118.39h-55.96Zm-586.5 30.19q-28.64 0-48.46-19.81-19.81-19.82-19.81-48.46v-528.52q0-28.34 19.81-48.25 19.82-19.92 48.46-19.92h528.52q28.34 0 48.25 19.92 19.92 19.91 19.92 48.35v190.11h-55.96v-100.88H121.5v439.19q0 5.39 3.46 8.85t8.85 3.46h502.84v55.96H133.81ZM121.5-711.19h553.04v-33.27q0-5.39-3.46-8.85-3.47-3.46-8.85-3.46H133.81q-5.39 0-8.85 3.46t-3.46 8.85v33.27Zm0 0V-756.77v45.58Z"/>
   </svg>
  )
}
export default IconAddFolder 